import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../../../..';
import ApiaApi, {
  IApiaApiRequestConfig,
  makeApiaUrl,
} from '../../../../../api/apiaApi/apiaApi';
import { TApiaModalRefreshDataResponse } from '../../../../../components/apia/execution/fields/apiaFinder/types';
import { arrayOrArray } from '../../../../../utils/util';
import { buttonsActions } from '../../../../buttonsSlice';
import { TAsyncThunkState, TListRowsStructure } from '../../../types';
import { parseRows } from '../../util/rowsParser';
import { TQueriesActionsChain } from '../../../queueController';

export type TRefreshData = {
  listId: string;
  url?: string;
  requestConfig?: IApiaApiRequestConfig<unknown>;
  pageNumber?: number;
  queryData?:
    | {
        workingMode: string;
      }
    // eslint-disable-next-line @typescript-eslint/ban-types
    | {};
  queueKey?: TQueriesActionsChain;
};

type TRefreshDataResponse = TApiaModalRefreshDataResponse;

const page = createAsyncThunk<
  TListRowsStructure,
  TRefreshData,
  TAsyncThunkState
>(
  'querySlice/pagination',
  async ({ listId, requestConfig, url, pageNumber, queryData }, thunkApi) => {
    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: true,
          action: 'disableTable',
        },
      ]),
    );
    const state = thunkApi.getState().querySlice.queries[listId];

    const response = await ApiaApi.post<TRefreshDataResponse>(
      url ??
        makeApiaUrl({
          action: 'page',
          pageNumber: pageNumber ?? '',
          ajaxUrl: state.ajaxUrl,
          react: true,
        }),
      { ...requestConfig, ...(queryData ? { queryData } : null) },
    );

    const pageInfo = response?.data?.function?.messages?.result?.pageInfo;
    const row = response?.data?.function?.messages?.result?.table?.row;

    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: false,
          action: 'disableTable',
        },
      ]),
    );

    return {
      pageInfo: pageInfo ?? undefined,
      rows: parseRows(listId, (row && arrayOrArray(row)) || []),
    };
  },
);

export default page;
